/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Arya Mirani",
  title: "Hi all, I’m Arya",
  subTitle: emoji(
    "An aspiring engineer and a Computer Science undergraduate at IIIT Hyderabad (Class of 2028), with a strong foundation in Linux, shell scripting, and backend development. I'm currently exploring web security, SQL, and system-level programming—driven by curiosity, a love for clean systems, and a mission to master both the theoretical and practical sides of modern computing. "
  ),
  resumeLink: "gogo", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/aryamirani",
  linkedin: "https://www.linkedin.com/in/arya-r-mirani/",
  gmail: "aryamirani06@gmail.com",
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills",
  subTitle: "",
  skills: [
    //emoji(
    //"⚡ Developed FOCUS – An indegenous propreitary framework that tracks and monitors ports for network security. "
    //),
    //emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    //emoji(
    //"⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    //)
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // Web Technologies
    {
      skillName: "HTML",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Express",
      fontAwesomeClassname: "fas fa-server" // No official icon for Express, symbolic
    },
    // Databases
    {
      skillName: "My SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf" // Not official, but commonly used as MongoDB icon fallback
    },
    // Programming Languages
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "fas fa-code" // No official icon for C++, fallback
    },
    {
      skillName: "Assembly",
      fontAwesomeClassname: "fas fa-microchip" // Symbolic icon for Assembly
    },
    {
      skillName: "xv6 Shell",
      fontAwesomeClassname: "fas fa-terminal" // Symbolic icon for shell
    },
    // Tools & Platforms
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "Wireshark",
      fontAwesomeClassname: "fas fa-network-wired" // Symbolic icon for Wireshark
    },
    
    {
      skillName: "FastAPI",
      fontAwesomeClassname: "fas fa-bolt" // No official icon for FastAPI, symbolic
    }
    //{
    //skillName: "react",
    //fontAwesomeClassname: "fab fa-react"
    //}
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "IIIT Hyderabad",
      logo: require("./assets/images/iiit.jpg"),
      subHeader: "Undergrad in Computer Science and Engineering",
      duration: "August '24 – June '28",
      desc: "CGPA : 8.0"
      //descBullets: [
      //  "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //  "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Indian School Wadi Kabir",
      logo: require("./assets/images/iiit.jpg"),
      subHeader: "Highschool Diploma with CSE & Math",
      duration: "Nov '21 - May '24",
      desc: "AISSCE : 95 %",
      descBullets: ["Head of IT Club, '23 - '24", "Table Tennis Captain, 2024"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Python", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "C++",
      progressPercentage: "70%"
    },
    {
      Stack: "Sql",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Accessibility Developer Intern",
      company: "IIIT Hyderabad",
      companylogo: require("./assets/images/iiit.jpg"),
      date: "December 2025 - January 2026",
      desc: "Digitized educational curriculums, focusing on creating inclusive technological solutions for special children.",
      descBullets: [
        `Translated complex educational requirements into accessible, high-performance digital tools.`,
        `Took a proactive approach to identifying and resolving critical accessibility hurdles.`,
        `Developed software specifically tailored to user (who were kids with special needs).`
      ]
    },
    {
      role: "Software Developer Intern",
      company: "Hustlr",
      companylogo: require("./assets/images/hustlr.png"),
      date: "June 2025 - August 2025",
      desc: "Contributed to the full-stack development of the Hustlr mobile app platform.",
      descBullets: [
        `Set up the foundational structure and baseline functionality of the Hustlr mobile app`,
        `Led the development of core user flows for onboarding and login screens`,
        `Built and refined profile interfaces for both student and client users`
      ]
    },
    {
      role: "Data Analyst Intern",
      company: "GeniusHub",
      companylogo: require("./assets/images/genius.jpg"),
      date: "June 2024 – July 2024",
      desc: "Analyse and extrapolate data",
      descBullets: [
        `Cleaned and Transformed raw datasets into structured formats for further analysis.`,
        `Interpreted data and analyzed results using various statistical techniques.`
      ]
    },
    {
      role: "Vice - President of Tech",
      company: "K12 Activity Academy Ltd.",
      companylogo: require("./assets/images/k12.png"),
      date: "Mar 2021 – Dec 2021",
      desc: "Facilitate and manage the IT Load of a Model Company called INVENT ISWK.",
      descBullets: [
        `Managed the largest team consisting of more than 90 students.`,
        `Collaborated with cross-functional teams to organize and handle large crowds for functions in the school campus.`
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Certifications",
  //subtitle: "Certifications that I have gotten",
  projects: [
    {
      image: require("./assets/images/ibm.png"),
      projectName: "Python 101 for Data Science ",
      projectDesc:
        "Provided by CognitiveClass and IBM Developer Skills Network",
      footerLink: [
        {
          name: "Validation",
          url: "https://courses.cognitiveclass.ai/certificates/53909bd5f5174256aca55465abed554f"
        }
        //  you can add extra buttons here.
      ]
    },
    {
    image: require("./assets/images/udemy.webp"),
    projectName: "OSINT from Scratch",
    projectDesc: "Provided by Z-Security, on Udemy",
    footerLink: [
    {
    name: "Validation",
    url: "https://www.udemy.com/certificate/UC-b486a163-a444-491f-9410-b7cac0533500/"
    }
    ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Startup Aid 2nd Runners Up",
      subtitle: "2nd Runners Up at the Startup Aid Competition '25 @ IIITH.",
      image: require("./assets/images/ecell.jpg"),
      imageAlt: "Photo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        }
      ]
    },
    {
      title: "ACQUITY 2023 Runners Up",
      subtitle: "Runners Up at the largest tech showdown event in Oman, 2023",
      image: require("./assets/images/iswk.png"),
      imageAlt: "image",
      footerLink: [
        {
          name: "Certificate",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "MECKATHON 2022 Runners Up",
      subtitle: "Runners Up at the National Hackathon Event in Oman, 2022",
      image: require("./assets/images/mega.jpeg"),
      imageAlt: "Image",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/13EWTNA5Nsc6PDHj5ILyTqyuHf8lhfBPO/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Projects",
  subtitle: "Some major Projects that I have been a part of and developed.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://github.com/aryamirani/FOCUS",
      title: "FOCUS : Firewall Optimization Control Utility Software",
      description:
        "A network security tool that protects the device against Malware."
    },

    {
      url: "https://felicity.iiit.ac.in/infinium/",
      title: "Infinium '25 : Tech Fest @ IIIT Hyd",
      description:
        "Part of the team that developed the Infinium website."
    },
    {
      url: "https://github.com/aryamirani/VISION",
      title: "VISION : Personal Assistant for Windows",
      description:
        "It is a personal assistant with voice control and is secure behind facial recognition."
    },
    {
      url: "https://www.linkedin.com/feed/update/urn:li:activity:7321131613679943682/",
      title: "Smart Railway Track Condition Monitoring Bot",
      description:
        "As part of the IoT (Internet of Things) course, I and my team designed and developed a smart railway infrastructure monitoring system that leverages real-time sensing and machine learning for early fault detection."
    },
    {
      url: "https://github.com/AURA",
      title: "AURA : AI Powered Chatbot",
      description:
        "A chatbot with NLP that learns from the questions asked to it. Refers to Wikipedia."
    },
    {
      url: "https://github.com/StackUnderflowMegathon/Megathon24",
      title: "OVERTALE : Retro Game",
      description:
        "Made purely in C, Undertale is a horror retro game that is inspired from Squid Game's Red Light Green Light."
    },
    {
      url: "https://wirre.vercel.app/",
      title: "WIRRE - Compete in Commits",
      description:
        "The first arena for Competitive Software Engineering. "
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [""],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  url: "https://drive.google.com/file/d/15vA75ICOrKVxjbm8rOBpDHA2rcUsup32/view?usp=sharing",
  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "aryamirani06@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
